import { Injectable, Provider } from '@angular/core';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatDateFormats, NativeDateAdapter } from '@angular/material/core';

/**
 * Native date adapter that also reads typed dd.mm.yyyy. The stock NativeDateAdapter formats in the
 * locale but parses with Date.parse, which reads "01.02.2026" as January 2nd (or not at all).
 */
@Injectable()
export class GermanDateAdapter extends NativeDateAdapter {
  override parse(value: unknown, parseFormat?: unknown): Date | null {
    if (typeof value === 'string') {
      const match = /^\s*(\d{1,2})\.(\d{1,2})\.(\d{4})\s*$/.exec(value);
      if (match) {
        const date = new Date(+match[3], +match[2] - 1, +match[1]);
        // Reject 31.02.2026 instead of letting Date roll it over into March.
        return date.getDate() === +match[1] && date.getMonth() === +match[2] - 1 ? date : this.invalid();
      }
    }
    return super.parse(value, parseFormat);
  }
}

const GERMAN_DATE_FORMATS: MatDateFormats = {
  parse: { dateInput: null },
  display: {
    dateInput: { day: '2-digit', month: '2-digit', year: 'numeric' },
    monthYearLabel: { year: 'numeric', month: 'short' },
    dateA11yLabel: { year: 'numeric', month: 'long', day: 'numeric' },
    monthYearA11yLabel: { year: 'numeric', month: 'long' }
  }
};

/** Datepicker in German form: dd.mm.yyyy, weeks starting on Monday. */
export function provideGermanDateAdapter(): Provider[] {
  return [
    { provide: MAT_DATE_LOCALE, useValue: 'de-AT' },
    { provide: DateAdapter, useClass: GermanDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: GERMAN_DATE_FORMATS }
  ];
}
